export default "__VITE_ASSET__GOzLiPm5__"